/**
 * Top-of-canvas banner shown over the count-in on each infinite-mode
 * repeat from loop 3 onward (the first repeat gets the fuller
 * {@link LoopFinaleOverlay} "INFINITE MODE" card instead). Announces the
 * new playback speed plus a rotating hype line so a sped-up repeat reads
 * as a deliberate escalation rather than an unexplained count-in.
 *
 * Positioned at the top and `pointer-events: none` so the central
 * count-in numbers and the approaching first notes stay visible underneath.
 */
export interface LoopSpeedupBannerProps {
  /** Effective playback multiplier for this loop, e.g. 1.5. */
  speed: number;
  /** Rotating hype line for this loop. */
  message: string;
}

function formatMultiplier(speed: number): string {
  // Speeds step in 0.25 increments, so at most two decimals; drop any
  // trailing zeros ("2.00" → "2", "1.50" → "1.5").
  const rounded = Math.round(speed * 100) / 100;
  return `${rounded}×`;
}

export function LoopSpeedupBanner({ speed, message }: LoopSpeedupBannerProps) {
  return (
    <div className="loop-speedup-banner" data-testid="loop-speedup-banner">
      <div className="loop-speedup-card">
        <p className="loop-speedup-eyebrow">Speed up</p>
        <p className="loop-speedup-multiplier" data-testid="loop-speedup-multiplier">
          {formatMultiplier(speed)}
        </p>
        <p className="loop-speedup-message">{message}</p>
      </div>
    </div>
  );
}
